<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group
          label="Salesman"
          label-for="salesman"
        >
          <custom-v-select
            id="salesman"
            v-model="selectedSalesmans"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="salesmanOptions"
            label="text"
            placeholder="Select Salesman"
            multiple
            :close-on-select="false"
            :deselect-from-dropdown="true"
            @input="filtersChangeHandler"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          label="Month-Year"
        >
          <flat-pickr
            id="selectedMonth"
            v-model="selectedMonth"
            placeholder="Select Month"
            :config="flatpickrConfig"
          />
        </b-form-group>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {
  VBTooltip, BRow, BCol, BFormGroup,
} from 'bootstrap-vue'
import axios from 'axios'
import CustomVSelect from '@/components/UI/CustomVSelect.vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import MonthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index'
import 'flatpickr/dist/plugins/monthSelect/style.css'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BFormGroup,
    CustomVSelect,
    flatPickr,
  },
  data() {
    return {
      partyOptions: [],
      selectedParties: [],
      areaOptions: [],
      selectedAreas: [],
      salesmanOptions: [],
      selectedSalesmans: [],
      selectedMonth: '',
      flatpickrConfig: {
        dateFormat: 'Y-m',
        altInput: true,
        altFormat: 'F Y',
        plugins: [new MonthSelectPlugin({ shorthand: true, dateFormat: 'Y-m', altFormat: 'F Y' })],
      },
      chequeNumber: null,
    }
  },
  watch: {
    selectedMonth(newValue) {
      if (newValue) {
        const [year, month] = newValue.split('-')
        if (year && month) {
          this.filtersChangeHandler()
        }
      } else if (newValue === '') {
        this.filtersChangeHandler()
      }
    },
  },
  created() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      axios.get('/accounts/salesmans_options')
        .then(res => {
          this.salesmanOptions = res.data.data
        })
    },
    filtersChangeHandler() {
      const filtersdata = { }
      if (this.selectedSalesmans.length > 0) {
        filtersdata.salesman = this.selectedSalesmans.map(salesman => salesman.id)
      }
      if (this.selectedMonth) {
        const [year, month] = this.selectedMonth.split('-')
        if (year && month) {
          filtersdata.monthDate = `${year}-${month}-1`
        }
      }
      this.$emit('filtersUpdated', filtersdata)
    },
    formatMonthLabel(monthKey) {
      // Convert "2025-07" to "Jul 2025"
      const [year, month] = monthKey.split('-')
      const date = new Date(year, parseInt(month, 10) - 1, 1)
      return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' })
    },

    formatMonthDisplay(monthKey) {
      if (!monthKey) return ''
      const [year, month] = monthKey.split('-')
      const date = new Date(year, parseInt(month, 10) - 1, 1)
      return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    },
  },
}
</script>
